import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlignVerticalBottomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"align_vertical_bottom"}/>
}
